const hintKey = (requestId: string) => `ss:attachments-uploaded:${requestId}`;

/** Mark that Create Request just uploaded files for this request (web session hint). */
export function markAttachmentsUploadedForRequest(requestId: string): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(hintKey(requestId), String(Date.now()));
  } catch {
    // ignore quota / private mode
  }
}

/** Consume one-shot hint so Request Detail refetches attachments after create save. */
export function consumeAttachmentsUploadedHint(requestId: string): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  try {
    const key = hintKey(requestId);
    if (!sessionStorage.getItem(key)) {
      return false;
    }
    sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
